import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import PencilIcon from '~/components/SVG/Pencil.svg?react';

interface PencilProps {
  isError?: boolean;
  onClick?: () => void;
  isDisabled?: boolean;
  isButton?: boolean;
  testId?: string;
}

const styles = {
  icon:
    (isError = false, isDisabled = false, isButton = false) =>
    (theme: Theme) => ({
      width: '25px',
      height: '25px',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      margin: isButton ? 0 : undefined,
      color: isError ? theme.palette.error.main : theme.palette.grey.additionalGrey,
      opacity: isDisabled ? 0.7 : 1,
      '&:hover': {
        color: isDisabled
          ? isError
            ? theme.palette.error.main
            : theme.palette.grey.additionalGrey
          : theme.palette.primary.main,
      },
      [theme.breakpoints.down('sm')]: {
        width: '20px',
        height: '20px',
        margin: '0 0 0 10px',
      },
    }),
};

const Pencil = ({ isError, onClick, isDisabled, isButton, testId }: PencilProps) => {
  return (
    <Box
      component={PencilIcon}
      onClick={isDisabled ? undefined : onClick}
      data-testid={testId ?? 'pencil-icon'}
      sx={styles.icon(isError, isDisabled, isButton)}
    />
  );
};

export default Pencil;
